import React from 'react';
import i18n from 'i18n-js';

import { Button, Typography, Box, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { BaseModal } from 'components/UI';
import InfoIcon from '@mui/icons-material/Info';

const BrokerConnectFailureModal = ({ open, onClose }) => {
  return (
    <BaseModal size="xl" open={open} enableCloseButton={false} handleClick={onClose}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        p={3}
        textAlign="center"
      >
        <InfoIcon color="error" sx={{ fontSize: 40 }} />
        <Box
          mt={2}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
        >
          <Typography variant="h6" gutterBottom color="error">
            {i18n.t('organization.broker_connect.failure_title')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {i18n.t('organization.broker_connect.failure_description')}
          </Typography>
        </Box>

        <Box mt={6} />

        <Grid item container xs={5} justifyContent="center" alignItems="center">
          <Button variant="contained" color="primary" onClick={onClose} fullWidth>
            {i18n.t('common.close')}
          </Button>
        </Grid>
      </Box>
    </BaseModal>
  );
};

BrokerConnectFailureModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { BrokerConnectFailureModal };
